import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { MatchViewModel } from '../../backend/entryPoints/mapper/mapToMatchViewModel';
import { Table } from 'react-bootstrap';

function GameMonitor() {
    const { side } = useParams();

    const [match, setMatch] = useState<MatchViewModel>();

    useEffect(() => {
        // Create Interval to fetch and update game data every X seconds
    }, []);

    return (
        <div style={{ height: '100vh', width: '100vw', backgroundColor: '#000000' }}>
            <table>
                <tbody>
                    <tr style={{ height: '50vh' }}>
                        <td style={{ verticalAlign: 'middle' }}>Home Player 1</td>
                        <td>{match?.games[0].home_points}</td>
                    </tr>
                    <tr style={{ height: '50vh' }}>
                        <td style={{ verticalAlign: 'middle' }}>Guest Player 1</td>
                        <td>{match?.games[0].guest_points}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default GameMonitor;
